module.exports = __webpack_public_path__ + "img/texiao-_0000s_0002_3.f0dfc849.png";